import React from 'react';
import RiskBar, { RiskBarPropDef } from './RiskBar';

const RiskBarGrid: React.SFC<RiskBarGridPropDef> = ({ items }) => (
  <div className="risk-bar-grid">
    {items.map(item => (
      <RiskBar key={item.label} {...item} />
    ))}
  </div>
);

RiskBarGrid.defaultProps = {
  items: [],
};

export interface RiskBarGridPropDef {
  items: RiskBarPropDef[];
}

export default RiskBarGrid;
